import { render, staticRenderFns } from "./CartazPreview.vue?vue&type=template&id=063c166e&scoped=true"
import script from "./CartazPreview.vue?vue&type=script&lang=js"
export * from "./CartazPreview.vue?vue&type=script&lang=js"
import style0 from "./CartazPreview.vue?vue&type=style&index=0&id=063c166e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063c166e",
  null
  
)

export default component.exports